export default "__VITE_ASSET__BhfiXoqD__"